<template>
  <v-dialog v-model="dialogEdit" persistent width="100vw" class=""  scrollable>
  <v-card class="" v-if="loadingInit">
    <FullLoading :loading="loadingInit" />
  </v-card>
  <v-card class="" v-if="dataSource && !loadingInit" height="100vh">
   <div>
      <h2 class="txt-head ml-8">
        รายละเอียดของ Service
      </h2>
      <div :class="`px-${$vuetify.breakpoint.name !== 'lg'? '4':'10'}`">
        <v-row :class="$vuetify.breakpoint.name !== 'lg'? 'pt-2':'pt-2 px-16'">
        <v-col cols="4" sm="3" md="3" lg="3" class="pb-0">
          <p class="txt-font">ชื่อ Service</p>
        </v-col>
        <v-col cols="8" sm="6" md="6" lg="6" class="pb-0">
          <v-text-field
            v-model="dataSource.serviceName"
            placeholder="กรอกชื่อ Service"
            dense
            outlined
            :readonly="action=='view'"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row :class="$vuetify.breakpoint.name !== 'lg'? 'pt-0':'pt-0 px-16'">
        <v-col cols="4" sm="3" md="3" lg="3" class="pb-0">
          <p class="txt-font">URL WebSite</p>
        </v-col>
        <v-col cols="8" sm="6" md="6" lg="6" class="pb-0">
          <v-text-field
            v-model="dataSource.url"
            placeholder="กรอก URL WebSite"
            dense
            outlined
            :readonly="action=='view'"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row :class="$vuetify.breakpoint.name !== 'lg'? 'pt-0':'pt-0 px-16'">
        <v-col cols="4" sm="3" md="3" lg="3" class="pb-0">
          <p class="txt-font">Token</p>
        </v-col>
        <v-col cols="8" sm="6" md="6" lg="6" class="pb-0">
          <v-textarea
            id="serviceToken"
            v-model="dataSource.token"
            outlined
            rows="3"
            readonly
          >
          </v-textarea>
        </v-col>
        <v-col cols="1" sm="1" md="1" lg="1" :class="`pb-0 ${$vuetify.breakpoint.name === 'xs'? 'pt-0':''}`" :offset="`${$vuetify.breakpoint.name === 'xs'? '4':'0'}`">
        <v-tooltip bottom >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="gray"
              icon
              @click="copyToken"
            >
            <v-icon color="gray" >mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span class="label-table-action">คัดลอก</span>
        </v-tooltip>
        </v-col>
      </v-row>
      <v-row :class="$vuetify.breakpoint.name !== 'lg'? 'pt-0 pb-1':'pt-0 pb-1 px-16'">
        <v-col cols="4" sm="3" md="3" lg="3" class="pb-0">
          <p class="txt-font">รายละเอียด</p>
        </v-col>
        <v-col cols="8" sm="6" md="6" lg="6" class="pb-0">
          <v-textarea
            v-model="dataSource.comment"
            outlined
            placeholder="หมายเหตุ"
            rows="3"
            :readonly="action=='view'"
          ></v-textarea>
        </v-col>
      </v-row>
      <h2 class="txt-head ml-0">
        รายละเอียดของบริษัท
      </h2>
      <v-row :class="$vuetify.breakpoint.name !== 'lg'? 'pt-3':'pt-3 px-16'">
        <v-col cols="4" sm="3" md="3" lg="3" class="pb-0">
          <p class="txt-font">ชื่อเครือ</p>
        </v-col>
        <v-col cols="8" sm="6" md="6" lg="6" class="pb-0">
          <v-select
            v-if="action!=='view'"
            v-model="selectGroupCompany"
            :items="itemGroupCompany"
            item-text="nameEng"
            item-value="id"
            outlined
            dense
            placeholder="เลือกเครือ"
            @change="originData = false"
            :append-icon="!(action==='view')? '$dropdown':''"
          />
          <v-text-field
            v-else
            :value="itemGroupCompany.find(e => e.id == selectGroupCompany)? itemGroupCompany.find(e => e.id == selectGroupCompany).nameEng : ''"
            dense
            outlined
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row :class="$vuetify.breakpoint.name !== 'lg'? 'pt-0':'pt-0 px-16'">
        <v-col cols="4" sm="3" md="3" lg="3" class="pb-0">
          <v-row>
            <p class="txt-font ml-3">ชื่อบริษัท</p>
          </v-row>
        </v-col>
        <v-col cols="8" sm="6" md="6" lg="6" class="pb-0">
          <v-select
            v-if="action!=='view'"
            v-model="selectCompany"
            :items="itemCompany"
            item-text="nameEng"
            item-value="id"
            outlined
            dense
            @change="originData = false"
            :placeholder="selectGroupCompany? itemCompany.length==0? 'ไม่มี':'เลือกบริษัท':'กรุณาเลือกเครือ'"
            :readonly="!checkCompany"
            :append-icon="checkCompany? itemCompany.length == 0? '':'$dropdown':''"
          />
          <v-text-field
            v-else
            :value="itemCompany.find(e => e.id == selectCompany)? itemCompany.find(e => e.id == selectCompany).nameEng : ''"
            dense
            outlined
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row :class="$vuetify.breakpoint.name !== 'lg'? 'pt-0':'pt-0 px-16'">
        <v-col cols="4" sm="3" md="3" lg="3" class="pb-0">
          <v-select
            v-if="action!=='view'"
            v-model="selectType"
            :items="['ทั้งหมด','สายงาน','ฝ่ายงาน','ส่วนงาน','หน่วยงาน','กลุ่มงาน']"
            outlined
            dense
            @change="originData = false"
            :placeholder="selectCompany? 'เลือกประเภท':'กรุณาเลือกบริษัท'"
            :append-icon="selectCompany? '$dropdown':''"
            :readonly="!selectCompany"
          />
          <v-text-field
            v-else
            :value="selectType || ''"
            dense
            outlined
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="8" sm="6" md="6" lg="6" class="pb-0">
          <v-select
            v-if="action!=='view'"
            v-model="selectOrgChart"
            :items="itemOrgChart"
            item-text="nameTh"
            item-value="id"
            outlined
            dense
            :placeholder="selectType? itemOrgChart.length == 0? selectType=='ทั้งหมด'? 'ทั้งหมด':'ไม่มี':`เลือก${selectType}`:'กรุณาเลือกประเภท'"
            :append-icon="itemOrgChart.length == 0? '':'$dropdown'"
            :readonly="itemOrgChart.length == 0"
          />
          <v-text-field
            v-else
            :value="selectType=='ทั้งหมด'? 'ทั้งหมด':(itemOrgChart.find(e => e.id == selectOrgChart).nameTh || '')"
            dense
            outlined
            readonly
          ></v-text-field>
        </v-col>
      </v-row>

        <v-row class="mt-2">
          <h2 class="txt-head mr-5">
            ผู้อนุมัติ
          </h2>
          <v-btn
            v-show="action!=='view'"
            right
            rounded
            color="green"
            dark
            class="mr-6 mt-0"
            @click="openDialogAddAprover('add', '', '')"
          >
          <v-icon left dark color="white">fa-plus-circle</v-icon>
          เพิ่มผู้อนุมัติ
          </v-btn>
        </v-row>
        <v-row>
          <v-col
            v-for="(item, i) in approver"
            :key="i"
            cols="12"
            lg="6"
            md="6"
            sm="6"
            class="justify-space-between"
          >
            <v-card
              color="white"
            >
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <v-list-item three-line>
                    <v-list-item-avatar
                      tile
                      :size="$vuetify.breakpoint.name !== 'lg'? '80':'125'"
                    >
                    <v-avatar
                      size="120"
                      rounded
                    >
                      <v-img
                        class="card-header-userimg-border"
                        cover
                        v-on:error="onImgError(i)"
                        :lazy-src="require('@/assets/icons/no_user.png')"
                        :src="item.failed_image ? require('@/assets/icons/no_user.png') : item.userImg"
                        :alt="item.approverId"
                        aspect-ratio="1"
                        height="100%"
                      />
                    </v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-row>
                        <span class=" ml-3">ผู้อนุมัติลำดับที่ {{ i+1 }}</span>
                        <v-spacer/>
                        <v-btn
                          rounded
                          color="#2196F3"
                          dark
                          icon
                          small
                          class="btn-edit-dep mb-0 mr-1"
                          v-show="action!=='view'"
                          @click="openDialogAddAprover('edit', item, i)">
                          <v-icon dark color="white" small>fa-wrench</v-icon>
                        </v-btn>
                        <v-btn
                          rounded
                          color="#2196F3"
                          dark
                          icon
                          small
                          class="btn-del-dep mb-0 mr-3"
                          v-show="action!=='view'"
                          @click="checkRemove(item)">
                          <v-icon dark color="white" small>fa-trash</v-icon>
                        </v-btn>
                      </v-row>
                      <span class="">{{item.employeeId || '-'}}</span>
                      <span class="">{{item.approverName || '-'}}</span>
                      <span class="">{{item.position || '-'}}</span>
                      <span class="">{{item.email || '-'}}</span>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    <DialogAddAprover/>
  </div>
  <v-card-actions v-if="action==='edit'">
    <br>
    <v-spacer></v-spacer>
    <v-btn class="ma-2 create-orgchart-header-cancel-btn" tile color="red" dark @click="closeDialog()">
      <span class="font-weight-regular">
      ยกเลิก
      </span>
    </v-btn>
    <v-btn class="ma-2 create-orgchart-header-save-btn" tile color="success" @click="submitData()">
      <v-icon left>mdi-pencil</v-icon>
      <span class="font-weight-regular">
      บันทึก
      </span>
    </v-btn>
  </v-card-actions>
  <v-card-actions v-else>
    <v-spacer></v-spacer>
    <v-btn class="ma-2 create-orgchart-header-cancel-btn" tile color="primary" dark @click="closeDialog()">
      <span class="font-weight-regular">
      ปิด
      </span>
    </v-btn>
  </v-card-actions>
  </v-card>
  </v-dialog>
</template>
<script>
import {
  getUserByKeyword,
  editService,
  getServiceById,
  getCompanySelector,
  getChartPickerSelector,
  hostImageUrlv3
} from '@/API/API'
import swal from 'sweetalert'
import DialogAddAprover from '../_dialog/dialogAddApprover'
import { EventBus } from '@/EventBus'
import FullLoading from '../../_template/FullLoading.vue'

export default {
  components: {
    DialogAddAprover,
    FullLoading
  },
  props: {
    // dialogEdit: Boolean
  },
  data () {
    return {
      originData: true,
      dialogEdit: false,
      serviceName: '',
      urlName: '',
      note: '',
      allCompany: [],
      selectGroupCompany: '',
      selectCompany: '',
      selectType: '',
      selectOrgChart: '',
      itemGroupCompany: [],
      itemCompany: [],
      itemOrgChart: [],
      img: '',
      positionData: [{
        positionName: '',
        companyName: ''
      }],
      approver: [],
      dataSource: null,
      action: '',
      loadingInit: true,
      chartPickerSelector: [],
      server: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}`
    }
  },
  computed: {
    checkCompany () { return !!this.selectGroupCompany.length }
  },
  watch: {
    selectGroupCompany () {
      this.itemCompany = this.allCompany.result.filter(e => e.level === 'ชื่อบริษัท' && this.selectGroupCompany === e.pId)
      if (!this.originData) {
        this.selectCompany = ''
        this.selectType = ''
      }
    },
    selectCompany () {
      if (!this.originData) this.selectType = ''
    },
    async selectType () {
      if (!this.originData) await this.getChartSelector()
    }
  },
  mounted () {
    EventBus.$on('openDialogViewService', async (dialogEdit, item, action) => {
      await this.initDataService(item)
      this.dialogEdit = dialogEdit
      this.action = action
      this.originData = true
      // if (action === 'view') this.companyShow = (this.itemCompany.find(e => e.companyId === this.dataSource.companyId)).companyShortNameEng
    })
    EventBus.$on('addAprover', this.add)
  },
  created () {
    this.tokenUser = this.$store.state.token
    this.getCompanySelector()
  },
  beforeDestroy () {
    EventBus.$off('closeDialogViewService')
    EventBus.$off('openDialogViewService')
    EventBus.$off('addAprover')
  },
  methods: {
    copyToken () {
      const input = document.getElementById('serviceToken')
      input.select()
      document.execCommand('copy')
      input.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    async initDataService (item) {
      const self = this
      self.dataSource = null
      self.approver = []
      self.loadingInit = true
      const obj = { serviceId: item._id }

      try {
        const res = await getServiceById(self.tokenUser, obj)
        if (res.success) {
          self.dataSource = res.result
          self.selectGroupCompany = self.dataSource.groupCompanyId[0]
          self.selectCompany = self.dataSource.companyId[0]
          // serviceForOrg
          self.selectType = self.dataSource.serviceForOrg === '' || self.dataSource.serviceForOrg.type === '' ? 'ทั้งหมด' : self.dataSource.serviceForOrg.type
          self.selectOrgChart = self.dataSource.serviceForOrg === '' || self.dataSource.serviceForOrg.orgId === '' ? 'ทั้งหมด' : self.dataSource.serviceForOrg.orgId
          self.dataSource.approver.map(el => {
            if (el.userImg === '') {
              el.userImg = `${hostImageUrlv3}/_/${el.emailOneId}`
              self.approver.push({ ...el, failed_image: false })
            } else {
              el.userImg = `${hostImageUrlv3}/${el.userImg}/${el.emailOneId}`
              self.approver.push({ ...el, failed_image: false })
            }
            // if (el.userImg) {
            //   self.approver.push({ ...el, failed_image: false })
            // } else {
            //   self.approver.push({ ...el, failed_image: true })
            // }
          })
          await this.getChartSelector()
        } else {
          self.dataSource = []
        }
      } catch (error) {
        self.dataSource = []
        console.log(error)
      } finally {
        self.loadingInit = false
      }
    },
    async getCompanySelector () {
      this.loading = true
      try {
        const res = await getCompanySelector(this.tokenUser)
        if (res.success) {
          this.allCompany = res
          this.itemGroupCompany = this.allCompany.result.filter(e => e.level === 'ชื่อเครือ')
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getChartSelector () {
      this.loading = true
      const payload = {
        orgChartType: this.selectType === 'ทั้งหมด' ? '' : this.selectType || '',
        companyId: this.selectType === 'ทั้งหมด' ? '' : this.selectCompany
      }
      try {
        const res = await getChartPickerSelector(this.tokenUser, payload)
        if (res.success) {
          this.chartPickerSelector = res
          if (!this.originData) this.selectOrgChart = ''
          this.itemOrgChart = this.chartPickerSelector.result
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    pressSelectAll (objectname) {
      this.$nextTick(() => {
        if (this[`select${objectname}`].length === this[`item${objectname}`].length) {
          this[`select${objectname}`] = []
        } else {
          this[`select${objectname}`] = [...new Set(this[`item${objectname}`].map(x => x.id))]
        }
      })
    },
    onImgError (i) {
      this.approver[i].failed_image = true
    },
    toggleGroup () {
      this.$nextTick(() => {
        if (this.likesAllGroupCompany) {
          this.selectGroupCompany = []
        } else {
          var tempGroup = []
          this.itemGroupCompany.map(el => {
            tempGroup.push(el.nameEN)
          })
          this.selectGroupCompany = tempGroup
        }
      })
    },
    toggleCompany () {
      this.$nextTick(() => {
        if (this.likesAllCompany) {
          this.selectCompany = []
        } else {
          var tempCompany = []
          this.itemCompany.map(el => {
            tempCompany.push(el.id)
          })
          this.selectCompany = tempCompany
        }
      })
    },
    async getUser () {
      this.loadingInit = true
      var temp = []
      const obj = {
        search: ''
      }
      try {
        const res = await getUserByKeyword(obj, this.$store.state.token)
        if (res.success) {
          temp = res.result
          this.itemUser = temp
          this.states = temp
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingInit = false
      }
    },
    openDialogAddAprover (action, item, index) {
      EventBus.$emit('openDialogAddAprover', true, item, action, index)
    },
    add (value, index, action) {
      if (action === 'add') {
        this.approver.push({
          approverNo: 1,
          approverId: value.id,
          employeeId: value.employeeId,
          approverName: value.name,
          position: value.position,
          email: value.email,
          userImg: `${new URL(value.userImg).pathname.substring(1)}`,
          failed_image: false
        })
      } else if (action === 'edit') {
        this.approver[index].approverNo = index + 1
        this.approver[index].approverId = value.id
        this.approver[index].employeeId = value.employeeId
        this.approver[index].approverName = value.name
        this.approver[index].position = value.position
        this.approver[index].email = value.email
        this.approver[index].userImg = `${new URL(value.userImg).pathname.substring(1)}`
        this.approver[index].failed_image = value.failed_image || false
      }
      this.dataSource.approver = this.approver
    },
    remove (index) {
      this.positionData.splice(index, 1)
    },
    closeDialog () {
      EventBus.$emit('closeDialogViewService', true)
      this.dialogEdit = false
    },
    async submitData () {
      if (this.selectCompany === '' || !this.dataSource.serviceName || !this.dataSource.url || !this.dataSource.comment || this.selectType === '' || (this.selectType !== 'ทั้งหมด' && this.selectOrgChart === '')) {
        swal('Warning', 'กรุณากรอกข้อมูลให้ครบ', 'warning', {
          button: false,
          timer: 3000
        })
      } else if (this.approver.length === 0) {
        swal('Warning', 'กรุณาเพิ่มผู้อนุมัติ', 'warning', {
          button: false,
          timer: 3000
        })
      } else {
        this.loadingInit = true

        var tempApprover = []
        this.approver.map(el => {
          tempApprover.push({
            approverId: el.approverId,
            employeeId: el.employeeId,
            approverName: el.approverName,
            position: el.position,
            email: el.email,
            userImg: el.userImg
          })
        })

        const obj = {
          serviceId: this.dataSource._id,
          groupCompanyId: [this.selectGroupCompany],
          companyId: [this.selectCompany],
          serviceName: this.dataSource.serviceName,
          comment: this.dataSource.comment,
          url: this.dataSource.url,
          serviceForOrg: {
            type: this.selectType === 'ทั้งหมด' ? '' : this.selectType,
            orgId: this.selectType === 'ทั้งหมด' ? '' : this.selectOrgChart
          },
          serviceType: '5f89295ed444d3a72e3b4260',
          approver: tempApprover
        }
        // console.log(obj)
        try {
          const res = await editService(obj, this.tokenUser)
          if (res.success) {
            this.closeDialog()
            swal('สำเร็จ', 'บันทึกข้อมูลสำเร็จ', 'success', {
              button: false,
              timer: 2000
            })
          } else {
            if (res.msg === 'Duplicate keys Service Name') {
              swal('ไม่สามารถบึนทึกได้', 'ชื่อ service ซ้ำ', 'warning', {
                button: false,
                timer: 2000
              })
            }
          }
        } catch (error) {
          console.log('error', error)
          swal('ผิดพลาด', 'บันทึกข้อมูล ไม่สำเร็จ!', 'error', {
            button: false,
            timer: 2000
          })
        } finally {
          this.loadingInit = false
        }
      }
      // this.$router.go(-1)
    },
    checkRemove (item) {
      // var delId = id
      swal('ต้องการลบผู้อนุมัติคนนี้ ใช่หรือไม่!', {
        buttons: {
          cancel: 'ยกเลิก',
          catch: {
            text: 'ใช่',
            value: 'save'
          }
        }
      })
        .then((value) => {
          switch (value) {
            case 'save':
              // this.delCompany(delId)
              this.removeApprover(item)
              break
          }
        })
    },
    removeApprover (item) {
      // console.log('removeApprover', this.approver.indexOf(item))
      this.approver.splice(this.approver.indexOf(item), 1)
    },
    editApprover (item, index) {
      // console.log('editApprover', item)
      this.approver[this.approver.indexOf(item)] = {
        no: this.approver.indexOf(item),
        _approverIdid: item._id,
        employeeId: item.employeeId,
        nameTH: item.name,
        position: item.position,
        email: item.email,
        userImg: item.userImg,
        failed_image: false
      }
    }
  }
}
</script>
<style>
@import '../../../css/Create.css';
@import '../../../css/ShowService.css';
</style>
